import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { QueryIntent } from '@atlassian/search-ai/constants';
import { getSmartAnswerRoute } from '@atlassian/search-ai/query-intent-api';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useQueryIntent = (
	searchQuery: string,
): {
	loading: boolean;
	transformedQuery: string;
	queryIntent: QueryIntent;
} => {
	const { locale } = useIntl();
	const { activationId, cloudId, isAdminHubAIEnabled, orgId } = useSessionData();
	const [loading, setLoading] = useState(false);
	const [queryIntent, setQueryIntent] = useState(QueryIntent.DEFAULT);
	const [transformedQuery, setTransformedQuery] = useState('');

	const siteARI = `ari:cloud:confluence::site/${cloudId}`;
	const workspaceId = activationId
		? `ari:cloud:confluence:${cloudId}:workspace/${activationId}`
		: '';

	useEffect(() => {
		if (!searchQuery || !isAdminHubAIEnabled || !fg('confluence_advanced_search_query_intent')) {
			return;
		}

		const callGetSmartAnswerRoute = async () => {
			setLoading(true);
			await getSmartAnswerRoute({
				query: searchQuery,
				locale,
				siteId: siteARI,
				cloudId,
				orgId: orgId ?? '',
				workspaceId,
				product: 'confluence',
				setQueryIntent,
				setTransformedQuery,
			});
			setLoading(false);
		};

		void callGetSmartAnswerRoute();
	}, [locale, siteARI, searchQuery, isAdminHubAIEnabled, cloudId, workspaceId, orgId]);

	return {
		loading,
		transformedQuery,
		queryIntent,
	};
};
